import { useState } from "react";
import { useAppDispatch } from "../../hooks";
import { addAlert } from "../../slices/alert";
import { submitEmailToRecoverPassword } from "../../slices/auth";
import { generateTranslatedText } from "../../utils/boilerplate";
import { LifebuoyIcon } from "@heroicons/react/24/solid";
import { validateEmail } from "../../utils/validation";
import Card from "../layout/Card";
import TextInput from "../forms/TextInput";
import Button from "../layout/Button";

export default function ForgotMyPasswordForm() {
  const dispatch = useAppDispatch();

  // App level state
  const language = "EN";

  // Component level state
  const [state, setState] = useState({ email: "" });

  // Functions
  async function submitEmailForPasswordRecovery(e: any) {
    e.preventDefault();

    const { email } = state;
    if (email === "") {
      dispatch(
        addAlert(generateTranslatedText("email_required", language), "orange")
      );
      return;
    }

    // Validate email
    if (validateEmail(email) !== null) {
      dispatch(
        addAlert(generateTranslatedText("invalid_email", language), "orange")
      );
      return;
    }

    // Submit email for recovery
    const res: any = await dispatch(submitEmailToRecoverPassword({ email }));
    if (res.payload.status === 200) {
      dispatch(
        addAlert(
          generateTranslatedText("password_recovery_email_sent", language),
          "mint-green"
        )
      );
    } else {
      dispatch(
        addAlert(
          generateTranslatedText("password_recovery_email_error", language),
          "orange"
        )
      );
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Card */}
      <Card
        colour="white"
        borderColour="none"
        paddingX="px-8"
        paddingY="py-8"
        className=" w-full max-w-md space-y-8"
      >
        {/* Header */}
        <div>
          <a href="/">
            <img
              className="mx-auto h-12 w-auto rounded-lg"
              src="/img/logo/logo.svg"
              alt="RaiseDiversity"
            />
          </a>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-black dark:text-white">
            {generateTranslatedText("forgotten_password_title", language)}
          </h2>
          <p className="text-sm text-center mt-2 text-secondary dark:text-light italic">
            {generateTranslatedText("forgotton_password_subtext", language)}
          </p>
        </div>

        {/* Form */}
        <form
          className="mt-8 space-y-6"
          onSubmit={(e) => submitEmailForPasswordRecovery(e)}
        >
          <div className="-space-y-px rounded-md">
            <div>

              {/* Email */}
              <TextInput
                id="email"
                type="email"
                bgColour="white"
                borderClass="border border-black"
                label={generateTranslatedText("email", "EN")}
                showLabel={false}
                placeholder={generateTranslatedText("email_placeholder", "EN")}
                autoComplete="email"
                required={true}
                onChange={(e) => setState({ ...state, email: e.target.value })}
                value={state.email}
              />
            </div>
          </div>

          <div>
            <Button
              bgColour="dark-blue"
              borderColour="dark-blue"
              textColour="white"
              className="text-white"
            >
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <LifebuoyIcon
                  className="h-5 w-5 fill-white"
                  aria-hidden="true"
                />
              </span>
              {generateTranslatedText("submit", language)}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
